import * as React from 'react';

import ChevronRight from 'vectors/icons/pagination-chevron-right.svg';
import ChevronLeft from 'vectors/icons/pagination-chevron-left.svg';

import { PaginationContainer, PaginationButton } from './styled';

export const Pagination: React.FC<PaginationProps>  = ({ currentPage, numPages, type }) => {
  const nextPage = currentPage + 1;
  const previousPage = currentPage - 1;

  return (
    <PaginationContainer type={type}>
      {currentPage > 1 && (
        <>
          <PaginationButton
            to={`${previousPage === 1 ? `/${type}` : `/${type}/page/${previousPage}`}`}
            icon={<ChevronLeft />}
          />
          {currentPage > 2 && (
            <>
              <PaginationButton to={`/${type}`}>1</PaginationButton>
              {currentPage > 3 && (
                <PaginationButton>...</PaginationButton>
              )}
            </>
          )}
          <PaginationButton
            to={`${previousPage === 1 ? `/${type}` : `/${type}/page/${previousPage}`}`}
          >
            {previousPage}
          </PaginationButton>
        </>
      )}
      <PaginationButton isCurrentPage>{currentPage}</PaginationButton>
      {currentPage < numPages && (
        <>
          <PaginationButton to={`/${type}/page/${nextPage}`}>{nextPage}</PaginationButton>
          {currentPage + 2 <= numPages && (
            <>
              {currentPage + 3 <= numPages && (
                <PaginationButton>...</PaginationButton>
              )}
              <PaginationButton to={`/${type}/page/${numPages}`}>{numPages}</PaginationButton>
            </>
          )}
          <PaginationButton
            to={`/${type}/page/${nextPage}`}
            icon={<ChevronRight />}
          />
        </>
      )}
    </PaginationContainer>
  );
};

type PaginationProps = {
  currentPage: number;
  numPages: number;
  type: string;
};
